import { render, staticRenderFns } from "./Userterms.vue?vue&type=template&id=a481155c&scoped=true&"
import script from "./Userterms.vue?vue&type=script&lang=ts&"
export * from "./Userterms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a481155c",
  null
  
)

export default component.exports